import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { selectReconciliationConversationsOpen } from './reconciliation-conversations.selectors';

/**
 * `/attention/:id` (a private reconciliation conversation, #3944 made one-to-one by #3965) exists only while
 * `reconciliationConversations`, `studyAttention` and `notificationInbox` are all on (notifications restart L7).
 * Otherwise the URL falls through to not-found, as before the route existed; saved conversations are untouched and come
 * back when the flags are on again.
 */
export const studyAttentionCanMatch: CanMatchFn = () =>
  inject(Store).selectSignal(selectReconciliationConversationsOpen)();
